module.exports = __webpack_public_path__ + "static/murthovic-67d2f6f9c3094f606513f69866681774.jpg";